export const config = {
    clientId: "zPzAWvXTbkGN1MFRZJOoY9CY1XdqAJVL",
    domain: "pizzaluce.auth0.com",
    redirect: "http://localhost:3000/close-popup",
      // we will go over this redirect soon.
    logoutUrl: "http://localhost:3000",
    audience: "https://pizzaluce.auth0.com/api/v2/"
  };